import { render, staticRenderFns } from "./index-vendor-invoice.vue?vue&type=template&id=530022a4&scoped=true"
import script from "./index-vendor-invoice.vue?vue&type=script&lang=js"
export * from "./index-vendor-invoice.vue?vue&type=script&lang=js"
import style0 from "./index-vendor-invoice.vue?vue&type=style&index=0&id=530022a4&prod&lang=css"
import style1 from "./index-vendor-invoice.vue?vue&type=style&index=1&id=530022a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530022a4",
  null
  
)

export default component.exports